import './ContentChangedIndicator.scss';
import type { RootState } from '@generalTypes/rootStateTypes';
import { selectModifiedSinceLastReadInfo } from '@newStore/documentUI/documentUISelectors';
import { useSelector } from 'react-redux';

const ContentChangedIndicator: React.FC<{ href: string; height90?: boolean }> = ({
  href,
  height90,
}) => {
  const modifiedSinceLastReadText = useSelector((state: RootState) =>
    selectModifiedSinceLastReadInfo(state, href),
  );

  if (!modifiedSinceLastReadText) {
    return null;
  }

  return (
    <div
      className="redactie-content-changed-indicator"
      style={{ height: height90 ? '90%' : undefined }}
    >
      <div className="content-changed-container" style={{ width: '4px' }}>
        <div className="line" title={modifiedSinceLastReadText} />
      </div>
    </div>
  );
};

export default ContentChangedIndicator;
